module.exports = __webpack_public_path__ + "img/16.295c696a.png";